// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1MiOF","content":"styles_content__1DGug","tableWrap":"styles_tableWrap__1356s"};